const makeGeneralSelector = key => state => {
  return state.general.get(key)
}

export const getFixedEndpoint = makeGeneralSelector('fixedEndpoint')
export const getHistoryOpen = makeGeneralSelector('historyOpen')
export const getConfigString = makeGeneralSelector('configString')



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/state/general/selectors.ts